import React from 'react';
import { CurrencyInput, Field } from 'ui';
import ListFlowSection from '~/components/ListFlow/ListFlowSection';
import ListFlowAdvancedPricingOptions from '~/components/ListFlow/PriceSection/ListFlowAdvancedPricingOptions';
import ListFlowAutoPriceDrop from '~/components/ListFlow/PriceSection/ListFlowAutoPriceDrop';
import ListFlowMinimumOffer from '~/components/ListFlow/PriceSection/ListFlowMinimumOffer';
import ListFlowValueGuide from '~/components/ListFlow/PriceSection/ListFlowValueGuide';
import RequiredStar from '~/components/ListFlow/RequiredStar';
import { useModals } from '~/contexts/ModalsContext';
import { useListFlowCategory } from '~/hooks/listFlow/useListFlowCategories';
import { getListFlowCategory } from '~/store/listFlow/slices/info';
import {
  changePricing,
  getListFlowPricing,
} from '~/store/listFlow/slices/pricing';
import { isListFlowUsingDefaultParcel } from '~/store/listFlow/slices/shipping';
import { getListFlowPricingErrors } from '~/store/listFlow/ui';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowPriceSection: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const modals = useModals();
  const priceError = useAppSelector(getListFlowPricingErrors);
  const pricing = useAppSelector(getListFlowPricing);
  const selectedCategory = useAppSelector(getListFlowCategory);
  const useCategoryParcel = useAppSelector(isListFlowUsingDefaultParcel);
  const { data: category } = useListFlowCategory(selectedCategory?.id);

  return (
    <ListFlowSection title="Price">
      <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
        <div>
          <Field
            label={
              <span>
                Price <RequiredStar />
              </span>
            }
            id="price"
            error={priceError}
          >
            <CurrencyInput
              id="price"
              onChange={value =>
                dispatch(changePricing({ field: 'listPrice', value }))
              }
              value={pricing.listPrice}
            />
          </Field>
          <ListFlowValueGuide />
        </div>

        <Field label="Retail Price" id="retail_price">
          <CurrencyInput
            id="retail_price"
            onChange={value =>
              dispatch(changePricing({ field: 'retailPrice', value }))
            }
            value={pricing.retailPrice}
          />
        </Field>
      </div>

      <div className="mb-4">
        <button
          className="font-semibold underline"
          onClick={() => modals.openModal('listFlowEarningsModal', {})}
        >
          Calculate Earnings
        </button>
      </div>

      <ListFlowAutoPriceDrop />
      <ListFlowMinimumOffer />
      <ListFlowAdvancedPricingOptions />
    </ListFlowSection>
  );
};

export default ListFlowPriceSection;
